<template>
  <div class="magic-content">
    <magic-box v-if="!showWhiteList" />
    <white-list v-else />
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "entry",
  computed: {
    ...mapState('newMagicBox', ['showWhiteList'])
  },
  components: {
    MagicBox: () => import('./index'),
    WhiteList: () => import('./whiteList')
  },
  beforeDestroy() {
    this.$store.commit('newMagicBox/setShowWhiteList', false)
  }
}
</script>

<style scoped>

</style>